export const GRADES = [
  { value: 'Class of 2026', label: 'Class of 2026' },
  { value: 'Class of 2027', label: 'Class of 2027' },
  { value: 'Class of 2028', label: 'Class of 2028' },
  { value: 'Class of 2029', label: 'Class of 2029' },
  { value: 'Class of 2030', label: 'Class of 2030' },
  { value: 'Class of 2031', label: 'Class of 2031' },
  { value: 'Class of 2032', label: 'Class of 2032' },
]

export const GRADE_VALUES = GRADES.map((g) => g.value)
